"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
tslib_1.__exportStar(require("./components"), exports);
tslib_1.__exportStar(require("./extension/extension.decl"), exports);
tslib_1.__exportStar(require("./extension/menu-item.decl"), exports);
tslib_1.__exportStar(require("./extension/route.decl"), exports);
tslib_1.__exportStar(require("./extension/wrapper.decl"), exports);
tslib_1.__exportStar(require("./extension/placeholderComponent.dcl"), exports);
//# sourceMappingURL=index.js.map